import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SmallLoaderComponent} from './small-loader.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SmallLoaderComponent
    ],
    exports: [
        SmallLoaderComponent
    ]
})
export class SmallLoaderModule {
}
